<template>
  <div class="hi-lo-color-history">
    <Row type="flex">
      <Col id="hi-lo-history-black" class="hi-lo-history-bar">
        {{ $t("general.Red") }}
        <span>{{this.redPercentage}}%</span>
      </Col>
      <Col id="hi-lo-history-high" class="hi-lo-history-bar">
        {{ $t("general.Black") }}
        <span>{{this.blackPercentage}}%</span>
      </Col>
    </Row>
    <Row v-if="this.newArr" type="flex" justify="space-around">
      <Col class="hi-lo-history-trend-lot-col" v-for="(col, index) in this.newArr" :key="index">
        <div
          class="hi-lo-history-trend-lot-cell"
          :class="getCharClass(cell[0])"
          v-for="(cell, index) in col"
          :key="index"
        >
          <hi-lo-history-popper
            :game="game"
            :table-name="tableName"
            :cell-data="cell"
            :game-code="gameCode"
            :game-id="gameId"
          >{{ getChar(cell[0]) }}</hi-lo-history-popper>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import HiLoHistoryPopper from "../widgets/HiLoHistoryPopper";
import { TimelineMax } from "gsap";

export default {
  props: ["stat", "historicalData", "game", "gameCode", "gameId", "tableName"],
  components: {
    Row,
    Col,
    HiLoHistoryPopper
  },
  data() {
    return {
      newArr: [],
      tempArr: [],
      totalRow: 18,
      blackPercentage: 0,
      redPercentage: 0,
      previousBadgeCount: 0
    };
  },
  methods: {
    getCharClass: function getCharClass(value) {
      if (value.length == 2) return value.charAt(1);
      if (value.length == 6) return value.charAt(5);
    },
    getChar: function getChar(value) {
      if (value.length == 2) {
        if (value.charAt(1) == "R") {
          return this.$t("hi_lo.o3_trend");
        } else if (value.charAt(1) == "B") {
          return this.$t("hi_lo.o4_trend");
        }
      }
      if (value.length == 6) return "JK";
    },
    triggerBlinkingEffect() {
      this.$nextTick(() => {
        let animationTl = new TimelineMax();

        animationTl
          .to(
            "#game-" +
              this.gameId +
              " .hi-lo-history-trend-lot-col:last-of-type .hi-lo-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 0
            }
          )
          .to(
            "#game-" +
              this.gameId +
              " .hi-lo-history-trend-lot-col:last-of-type .hi-lo-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 1
            }
          );
        animationTl.repeat(4);
      });
    }
  },
  watch: {
    historicalData() {
      let index = 0;
      let tempData = [...this.historicalData];
      this.tempArr = [];
      this.blackPercentage = 0;
      this.redPercentage = 0;

      for (var i = 0; i < tempData.length; i++) {
        let temp = [];

        if (tempData[i]["c_color"] == this.$t("hi_lo.o3_trend")) {
          this.redPercentage++;
        }
        if (tempData[i]["c_color"] == this.$t("hi_lo.o4_trend")) {
          this.blackPercentage++;
        }

        temp.push(tempData[i]["c_card"] + tempData[i]["c_color"]);
        temp.push(tempData[i]["p_card"] + tempData[i]["p_color"]);
        temp.push(tempData[i]["draw_no"], tempData[i]["draw_datetime"]);
        temp.push(tempData[i]["hl"]);
        this.tempArr.push(temp);
      }
      this.tempArr.reverse();

      (index = 0),
        (this.newArr = this.tempArr.reduce((result, data, i, array) => {
          if (
            !array[i - 1] ||
            data[index].charAt(1) !== array[i - 1][index].charAt(1) ||
            result[result.length - 1].length === 5
          )
            result.push([]);
          result[result.length - 1].push(data);
          return result;
        }, []));

      this.newArr.reverse();
      this.newArr.splice(this.totalRow);
      this.newArr.reverse();
      this.triggerBlinkingEffect();

      let emitArr = ["r_b", "general.RED_BLACK"];
      let tempValue = 0;

      if (
       this.newArr[this.totalRow - 1][0][0] ==
          this.newArr[this.totalRow - 3][0][0] &&
        this.newArr[this.totalRow - 1][0][0] ==
          this.newArr[this.totalRow - 2][0][0]
      ) {
        tempValue =
          this.newArr[this.totalRow - 1].length +
          this.newArr[this.totalRow - 2].length +
          this.newArr[this.totalRow - 3].length;
      } else if (
        this.newArr[this.totalRow - 1][0][0] ==
        this.newArr[this.totalRow - 2][0][0]
      ) {
        tempValue =
          this.newArr[this.totalRow - 1].length +
          this.newArr[this.totalRow - 2].length;
      } else {
        tempValue = this.newArr[this.totalRow - 1].length;
      }

      if (tempValue > 3) emitArr.push(tempValue);
      else {
        emitArr.push(0);
        tempValue = 0;
      }

      emitArr.push(this.newArr[this.totalRow - 1][0][0].charAt(1));

      if (this.newArr[this.totalRow - 1][0][0].charAt(1) == "R") {
        emitArr.push("goodRoadIconRed");
      } else if (this.newArr[this.totalRow - 1][0][0].charAt(1) == "B") {
        emitArr.push("goodRoadIconBlack");
      } else {
        emitArr.push("goodRoadIconBlue");
      }

      if (this.previousBadgeCount != tempValue) {
        this.$emit("get-badge-count", emitArr);
      }

      this.previousBadgeCount = tempValue;
    }
  }
};
</script>

<style lang="scss">
.hi-lo-history-trend-lot-cell {
  color: white;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 100px;
  margin-top: 6px;
  cursor: pointer;
  overflow: hidden;
}
.hi-lo-history-trend-lot-cell.R {
  background: $hilo-trend-lot-color-2;
}

.hi-lo-history-trend-lot-cell.B {
  background: $hilo-trend-lot-color-4;
}

.hi-lo-history-trend-lot-cell.J {
  background: $hilo-trend-lot-color-1;
}
</style>
